// extracted by mini-css-extract-plugin
export default {"letter":"styles_letter__OM5pi","red":"styles_red__j5MmF","accent":"styles_accent__7mk+8","sign":"styles_sign__pk5g+","title":"styles_title__0A4f2","logo":"styles_logo__KULSR"};